export default "/images/timetables.jpg?92716dc9fe5d109bb3e2d6095dea5b08";